import type { Translation } from '../types.ts';
import type en from '../en/menus.ts';

export default {
    shared: {
        topLevel: 'Hoofdniveau',
        noText: '(geen tekst)',
        invalid: 'Ongeldig',
    },
    list: {
        title: "Menu's",
        add: 'Item toevoegen',
        savingOrder: 'Volgorde opslaan…',
        noMenus: "Het actieve thema roept nergens {fn} aan, dus er zijn geen menu's om te beheren. Voeg een {loop}-lus toe aan de templates van je thema, deploy opnieuw en laad deze pagina daarna opnieuw.",
        help: 'Sleep een rij aan de greep. Zet hem neer op de {edges} van een andere rij om de volgorde te wijzigen, of in het {middle} om hem eronder te nesten. De navigatietekst is de titel van de gekoppelde pagina, tenzij je die overschrijft.',
        helpEdges: 'boven- of onderrand',
        helpMiddle: 'midden',
        pageTitle: 'paginatitel',
        pageTitleHint: 'Gebruikt de titel van de gekoppelde pagina',
        nestedUnder: 'Genest onder {parent}',
        childOf: 'onder {parent}',
        pageRef: 'pagina #{id}',
        confirmRemove: '"{name}" uit dit menu verwijderen?',
        empty: 'Nog geen items voor dit menu en deze taal.',
        addOne: 'Voeg er een toe',
    },
    edit: {
        editTitle: 'Menu-item bewerken',
        newTitle: 'Nieuw menu-item',
        menu: 'Menu',
        locale: 'Taal',
        page: 'Gekoppelde pagina',
        pageHint: 'Laat leeg voor een vrij anker of een externe link.',
        pageHome: '{title} (startpagina)',
        label: 'Navigatietekst',
        labelExample: 'Contact',
        labelHintPage: 'Leeg = de paginatitel gebruiken.',
        labelHintFree: 'Verplicht voor vrije items.',
        href: 'Href',
        hrefPlaceholder: '#contact of /over-ons#team of https://example.com',
        hrefHint: 'Anker op de pagina, relatieve URL met #anker, of absolute URL.',
        parent: 'Bovenliggend menu-item',
        parentHint: 'Nest dit item onder een ander menu-item, of laat het op het hoofdniveau staan.',
        newTab: 'Openen in een nieuw tabblad',
        newTabHint: 'Voor een pdf of een andere link die de site niet mag vervangen.',
    },
} satisfies Translation<typeof en>;
